// extracted by mini-css-extract-plugin
export default {"contentContainer":"Home_contentContainer__FCOgh","cardsBoxers":"Home_cardsBoxers__FrBpX","contentCard":"Home_contentCard__SCZ8S"};